import { render } from "./Overdue.vue?vue&type=template&id=ac6a6084"
import script from "./Overdue.vue?vue&type=script&lang=js"
export * from "./Overdue.vue?vue&type=script&lang=js"

import "./Overdue.vue?vue&type=style&index=0&id=ac6a6084&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__